export const PATHS = {
  HOME: "/",
  HOME_B: "/qr-code-generator",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  TERMS_OF_USE: "/terms-of-use",
  PRIVACY_POLICY: "/privacy-policy",
  COOKIES_POLICY: "/cookies-policy",
  IMPRESSUM: "/impressum",
  TOKUTEI_SHOTORIHIKI: "/tokutei-shotorihiki",
  CONTACT_US: "/contact-us",
  FAQ: "/faq",
  PRICING: "/pricing",
  WHOWEARE: "/who-we-are",
  QR_EDITOR: "/qr-editor",
  DESIGN: "/design",
  NOT_FOUND: "/404",
  MY_ACCOUNT: "/my-account",
  MY_QR_CODES: "/my-qr-codes",
  MY_QR_CODES_DETAILS: "/my-qr-codes-details",
  MY_QR_CODES_REVIEWS: "/my-qr-codes-reviews",
  BULK_CREATOR: "/bulk-creator",
  TEMPLATES: "/templates",
  DESIGN_TEMPLATE: "/templates/design",
  MY_QR_ANALYTICS: "/my-qr-analytics",
  MY_BILLING: "/my-billing",
  PAYMENT: "/payment",
  THANK_YOU: "/thank-you",
  VERIFY_PAYMENT: "/verify-payment",
  QR_URL: "/url",
  INACTIVE: "/inactive",
  RESET_PASSWORD: "/reset-password",
  SET_PASSWORD: "/set-password",
  USERS: "/users",
  UNSUBSCRIBE: "/unsubscribe",
  UNSUBSCRIBE_REASONS: "/unsubscribe-reasons",
  UNSUBSCRIBE_CONFIRMATION: "/unsubscribe-confirmation",
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  ABOUT_US: "/about-us",
  HOW_WE_ARE: "/how-we-are",
  QRCREATOR_DEV_SCAN_TOOL: "/qrcreator-dev-scan-tool",
};

export const SPECIAL_ROUTES = ["/qr/", "/p/", "/auth/"];

export type Path = (typeof PATHS)[keyof typeof PATHS];
export type SpecialRoute = (typeof SPECIAL_ROUTES)[number];

export const isAuthenticationPage = (path: string): boolean => {
  return (
    path.startsWith(PATHS.LOGIN) ||
    path.startsWith(PATHS.SIGNUP) ||
    path.startsWith(PATHS.FORGOT_PASSWORD) ||
    path.startsWith(PATHS.RESET_PASSWORD) ||
    path.startsWith(PATHS.SET_PASSWORD)
  );
};

const ALL_PATHS = Object.values(PATHS);

/**
 * Checks if a pathname matches any known app route defined in PATHS.
 * Unknown routes (e.g. /notRealURL) return false so the middleware
 * can let them pass through to Next.js, which will render the 404 page.
 * @param pathname - The normalized pathname (without locale prefix)
 */
export const isKnownAppRoute = (pathname: string): boolean => {
  return ALL_PATHS.some((route) => pathname === route || pathname.startsWith(route + "/"));
};

/**
 * Routes that mount the Stripe Express Checkout Element and need to keep
 * the thread + network not blockedd during boot. Non-critical third-party
 * scripts (GTM, Amplitude...) should be deferred here so they
 * don't steal sockets/CPU from Stripe ECE (QRWMAU-1152)
 *
 * Accepts the raw pathname from `usePathname()`.
 */
export const isStripeCriticalPath = (pathname?: string | null): boolean => {
  if (!pathname) return false;
  return /(^|\/)(pricing|payment)(\/|$)/.test(pathname);
};
